import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API1,
  withCredentials: false,
  timeout: 30000
})

service.interceptors.request.use(
  (config) => config,
  (error) => {
    console.error(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    const { code, resultCode } = response.data
    if ((code && code !== 200) || (resultCode && resultCode !== 200)) {
      return Promise.reject(new Error(response.data.message))
    } else {
      return response.data
    }
  },
  (error) => Promise.reject(error)
)

export default service
